module.exports = __webpack_public_path__ + "img/bg_10.d6baf515.jpg";